
/**
 * Storage Configuration
 * Created: 2025-05-24
 * Updated: 2025-01-30 - Phase 4: Simplified storage paths, consistent structure
 * Updated: 2025-01-18 - Added finance documents bucket
 * 
 * Centralized storage configuration to ensure consistent bucket naming
 * throughout the application
 */

// Storage buckets used in the application
export const STORAGE_BUCKETS = {
  CAR_IMAGES: 'car-images',        // Car listing photos
  CAR_FILES: 'car-files',          // Finance documents & seller docs
  MANUAL_PHOTOS: 'manual-valuation-photos', // Manual valuation photos
};

// Legacy constant for backward compatibility
export const STORAGE_BUCKET = STORAGE_BUCKETS.CAR_IMAGES;

// Storage path prefixes - Phase 4: Simplified consistent structure
export const STORAGE_PATHS = {
  // All car images stored as: cars/{userId}/{category}/filename
  CARS: 'cars/',
  DAMAGE: 'damage_photos/',
  FINANCE_DOCS: 'finance_documents/', // NEW: For car-files bucket
};

// Helper to get finance document path
export const getFinanceDocPath = (userId: string, fileName: string): string => {
  const timestamp = Date.now();
  const sanitized = fileName.replace(/[^a-zA-Z0-9.-]/g, '_');
  return `${STORAGE_PATHS.FINANCE_DOCS}${userId}/${timestamp}_${sanitized}`;
};

// Local storage keys that may contain stale bucket references
export const LOCAL_STORAGE_KEYS = {
  TEMP_UPLOADS: 'temp_car_uploads',
  TEMP_PHOTOS: 'tempPhotos',
  VEHICLE_PHOTOS: 'vehiclePhotos'
};

/**
 * Utility to clear stale storage references from localStorage
 * Should be called during app initialization
 */
export const clearStaleLocalStorage = (): void => {
  try {
    Object.values(LOCAL_STORAGE_KEYS).forEach(key => {
      const data = localStorage.getItem(key);
      
      // Check if the item exists and contains reference to wrong bucket
      if (data && data.includes('car-photos')) {
        console.warn(`[StorageConfig] Removing stale localStorage data with incorrect bucket reference: ${key}`);
        localStorage.removeItem(key);
      }
    });
    
    console.log('[StorageConfig] Stale storage references cleared');
  } catch (e) {
    console.error('[StorageConfig] Error clearing storage:', e);
  }
};

